const AUTHORIZED_ENVS = ['staging', 'barney', 'wip', 'test', 'development'];

export default AUTHORIZED_ENVS.includes(window.__HB_ENV__.CLUSTER_NAME) ||
  AUTHORIZED_ENVS.includes(window.__HB_ENV__.ENVIRONMENT);
